class ModalEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event() {
    const buttonOpen = document.querySelectorAll('.modalOpen');
    const modal = document.querySelector('.modal');
    const buttonClose = document.querySelector('.modalClose');
    const body = document.querySelector('body');

    buttonOpen.forEach((el) => {
      el.addEventListener('click', function() {
        modal.classList.add('open');
        body.classList.add('open');
      });
    })
  
    // バツ印がクリックされた時
    buttonClose.addEventListener('click', function() {
      modal.classList.remove('open');
      body.classList.remove('open');
    });

    // モーダルコンテンツ以外がクリックされた時
    modal.addEventListener('click', function(){ 
      modal.classList.remove('open');
      body.classList.remove('open');
    });
  }
}
